<template lang="html">
  <v-dialog
    v-model="dialog"
    max-width="500px"
    scrollable
    transition="dialog-transition"
  >
    <template #activator="{ on }">
      <div v-on="on">
        <slot name="activator" />
      </div>
    </template>
    <v-card>
      <v-card-title class="pa-0">
        <v-tabs
          v-model="tab"
          slider-color="primary"
          grow
          class="flex"
        >
          <v-tab>Not Picked</v-tab>
          <v-tab>Already Picked</v-tab>
        </v-tabs>
      </v-card-title>
      <v-card-text class="pa-0">
        <v-divider />
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <v-list>
              <v-scale-transition group>
                <v-list-item
                  v-for="field in filteredFields"
                  :key="field.name"
                  @click="addField(field.name)"
                >
                  <v-list-item-content>
                    <v-list-item-title>{{ field.name }}</v-list-item-title>
                    <v-list-item-subtitle class="caption">
                      {{ field.label }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn
                      text
                      icon
                      color="primary"
                      small
                    >
                      <v-icon>add</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
                <v-list-item v-if="(filteredFields || []).length === 0">
                  <v-list-item-title class="grey--text">
                    No more fields
                  </v-list-item-title>
                </v-list-item>
              </v-scale-transition>
            </v-list>
          </v-tab-item>

          <v-tab-item>
            <v-list>
              <v-list-item
                v-for="pickedField in pickedFields"
                :key="pickedField"
                @click="addField(pickedField)"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ (fields[pickedField] || {}).name }}</v-list-item-title>
                  <v-list-item-subtitle class="caption">
                    {{ (fields[pickedField] || {}).label }}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn
                    text
                    icon
                    color="primary"
                    small
                  >
                    <v-icon>add</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
              <v-list-item v-if="(picked || []).length === 0">
                <v-list-item-title class="grey--text">
                  No fields
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          color="primary"
          @click="dialog = false"
        >
          Done
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { includes } from 'lodash'
import helpers from '@/mixins/helpers'
export default {
  mixins: [ helpers ],
  props: {
    fields: Object,
    picked: [ Array ]
  },
  data () {
    return {
      tab: null,
      dialog: false
    }
  },
  computed: {
    pickedFields () {
      return (this.picked || []).sort((a, b) => { return a.localeCompare(b) })
    },
    filteredFields () {
      var arr = this._objectToArrayAplha(this.fields, 'name')
      return arr.filter(x => {
        return !includes(this.picked, x.name)
      })
    }
  },
  watch: {

  },
  methods: {
    addField (fieldName) {
      this.$emit('field', fieldName)
    }
  }
}
</script>

<style lang="css" scoped>
</style>
